import $ from 'jquery';

export default class Header {
    constructor() {
        // this.$languageSelect = $("#language-select");

        this.bind();
    }

    bind() {
        // this.setLanguageSelectOnLoad();
        // this.$languageSelect.on("change", this.updateLanuageCookie.bind(this));
    }

    // setLanguageSelectOnLoad() {
    //     const currentLang = this.getCookie('wp-wpml_current_language');

    //     if (currentLang && this.$languageSelect.find(`option[value="${currentLang}"]`).length > 0) {
    //         this.$languageSelect.val(currentLang);
    //     }
    // }

    // updateLanuageCookie(e) {
    //     const select = e.currentTarget;
    //     const selectedLanguage = select.value;

    //     document.cookie = `wp-wpml_current_language=${selectedLanguage}; path=/; max-age=31536000`;
    // }

    // getCookie(name) {
    //     const value = `; ${document.cookie}`;
    //     const parts = value.split(`; ${name}=`);
    //     if (parts.length === 2) return parts.pop().split(';').shift();
    //     return null;
    // }
}